import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function LinkedIn({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <LinkedIn.Outline {...props} />
  ) : (
    <LinkedIn.Solid {...props} />
  );
}

LinkedIn.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

LinkedIn.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M19.211 19.0413H16.2181V14.4004C16.2181 13.2937 16.1981 11.8691 14.6614 11.8691C13.1026 11.8691 12.8641 13.0749 12.8641 14.3199V19.041H9.87114V9.49741H12.7444V10.8016H12.7846C13.0721 10.3148 13.4877 9.91439 13.9869 9.64291C14.4861 9.37143 15.0503 9.23911 15.6195 9.26003C18.653 9.26003 19.2123 11.2357 19.2123 13.8059L19.211 19.0413ZM6.4941 8.19287C6.15058 8.19293 5.81476 8.09213 5.5291 7.90321C5.24344 7.71429 5.02079 7.44574 4.88928 7.13152C4.75776 6.81731 4.7233 6.47153 4.79025 6.13792C4.85721 5.80431 5.02258 5.49785 5.26544 5.2573C5.5083 5.01675 5.81774 4.8529 6.15465 4.78649C6.49155 4.72007 6.84077 4.75406 7.15816 4.88417C7.47555 5.01428 7.74685 5.23465 7.93775 5.51743C8.12865 5.8002 8.23058 6.13268 8.23064 6.47282C8.23068 6.69866 8.18579 6.92229 8.09854 7.13095C8.01129 7.33962 7.88341 7.52922 7.72215 7.68895C7.5609 7.84867 7.36944 7.97538 7.15873 8.06184C6.94803 8.1483 6.72219 8.19282 6.4941 8.19287ZM7.99057 19.0413H4.99451V9.49741H7.99057V19.0413ZM20.7031 2.00136H3.49055C3.09988 1.997 2.72341 2.14639 2.44392 2.4167C2.16443 2.68702 2.00477 3.05614 2 3.44297V20.5567C2.0046 20.9437 2.16417 21.3131 2.44365 21.5837C2.72314 21.8543 3.09968 22.004 3.49055 21.9999H20.7031C21.0948 22.0047 21.4724 21.8555 21.753 21.5849C22.0336 21.3143 22.1942 20.9445 22.1996 20.5567V3.44174C22.194 3.05414 22.0333 2.6846 21.7527 2.41429C21.4721 2.14398 21.0946 1.99502 20.7031 2.00013"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
